import axios from '@/lib/axios';
import { PaymentTask } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0970. 支払タスク登録
 * [POST] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_tasks
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  name: string;
  description?: string;
  payment_schedule_detail_id: number;
  due_date?: string;
};

const createPaymentTask = (props: Props): Promise<PaymentTask> => {
  return axios.post(`/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_tasks`, props);
};

export const useCreatePaymentTask = () => {
  return useMutation({
    mutationFn: createPaymentTask,
  });
};
